module.exports = {
      id: "icon-card-jcb-usage",
      viewBox: "0 0 44 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-card-jcb",
      toString: function () {
        return this.url;
      }
    }